<template>

	<div class="printView">

		<!-- show loading indicator -->
		<div class="container is-fluid" v-if="isLoading">
			<loading-indicator :loading="isLoading"></loading-indicator>
		</div>

		<template v-if="!isLoading">

			<div class="page">

				<div class="header is-clearfix">

					<h1>{{ pharmacy.site.name }}</h1>
					{{ pharmacy.site.address }}, {{ pharmacy.site.zipcode }} {{ pharmacy.site.city }}

					<template v-if="pharmacy.site.logoAsset">
						<img class="logo":src="$config.assets + '/' + pharmacy.site.logoAsset.path+'/'+pharmacy.site.logoAsset.filename" />
					</template>

				</div>

				<div class="section">

					<div class="columns">

						<div class="column">

							{{ $t('SITE_PHONE') }}: {{ pharmacy.site.phone }}<br />
							{{ $t('SITE_FAX') }}: {{ pharmacy.site.fax }}<br />
							{{ $t('SITE_EMAIL') }}: {{ pharmacy.site.email }}<br />
							<template v-if="pharmacy.site.website">{{ $t('SITE_WEBSITE') }}: {{ pharmacy.site.website }}<br /></template>
							<br />
							{{ $t('SITE_CONTACT_OWNER')}}: {{ pharmacy.site.contactPerson.fullName }}<br />
							{{ $t('SITE_SUPERVISOR') }}: {{ pharmacy.site.accountManager.fullName }}

						</div>

						<div class="column">

							<div class="openingHours" v-cloak v-html="getOpeningHours()"></div>

						</div>

					</div>

				</div>



				<h2>Katalogdaten</h2>

				<div class="section columns">

					<div class="column">

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_IS_SUBSCRIPTION')}}:</span>
							<span class="value">{{ pharmacy.isSubscription ? 'ja' : 'nein' }}</span>
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_QTY')}}:</span>
							<span class="value">{{ pharmacy.quantity }}</span>
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_REBATEINKIND')}}:</span>
							<span class="value">{{ pharmacy.rebateInKind }}</span>
						</div>


						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_HAS_SHIPMENT')}}:</span>
							<span class="value">{{ pharmacy.hasShipment ? 'ja' : 'nein' }}</span>
						</div>


						<template v-if="pharmacy.hasShipment">

							<div class="row">
								<span class="labelName">{{ $t('SITE_CATALOG_HAS_SHIPMENT_RECIPIENT_LIST')}}:</span>
								<span class="value">{{ pharmacy.hasShipmentRecipientList ? 'ja' : 'nein' }}</span>
							</div>

							<div class="row">
								<span class="labelName">{{ $t('SITE_CATALOG_SHIPMENT_RECIPIENT_LIST')}}:</span>
								<span class="value">{{ pharmacy.shipmentRecipientListQty }}</span>
							</div>

							<div class="row">
								<span class="labelName">{{ $t('SITE_CATALOG_SHIPMENT_AREA_ZIPCODES')}}:</span>
								<span class="value">{{ pharmacy.shipmentAreaZipcodes }}</span>
							</div>

							<div class="row">
								<span class="labelName">{{ $t('SITE_CATALOG_SHIPMENT_AREA_QTY')}}:</span>
								<span class="value">{{ pharmacy.shipmentAreaQty }}</span>
							</div>

						</template>

					</div>

					<div class="column">

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_USE_FOIL_COATING')}}:</span>
							<span class="value">{{ pharmacy.useFoilCoating ? 'ja' : 'nein' }}</span>
						</div>

						<div class="row" v-if="pharmacy.useFoilCoating">
							<span class="labelName">{{ $t('SITE_CATALOG_USE_FOIL_COATING_REST')}}:</span>
							<span class="value">{{ pharmacy.useFoilCoatingForRemainingQuantity ? 'ja' : 'nein' }}</span>
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_PROMOTION_MATERIAL_PACKAGE_QTY')}}:</span>
							<span class="value">{{ pharmacy.promotionMaterialPackageQty }}</span>
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_HAS_COUPON_BOX')}}:</span>
							<span class="value">{{ pharmacy.couponBoxQty }}</span>
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_COUPONS_QTY')}}:</span>
							<span class="value">{{ pharmacy.couponSetQty }}</span>
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_IS_CANCELLED')}}:</span>
							<span class="value">{{ pharmacy.isCancelled ? 'ja' : 'nein' }}</span>
						</div>

						<div class="row" v-if="pharmacy.isCancelled">
							<span class="labelName">{{ $t('SITE_CATALOG_CANCELLATION_REASON')}}:</span>
							<span class="value">{{ pharmacy.cancellationReason }}</span>
						</div>

					</div>

				</div>

				<div class="section">

					<template v-if="pharmacy.notes != null && pharmacy.notes != ''">
						<span class="labelName">{{ $t('SITE_CATALOG_COMMENT1')}}:</span>
						{{ pharmacy.notes }}
					</template>

					<template v-if="pharmacy.comments != null && pharmacy.comments != ''">
						<span class="labelName">{{ $t('SITE_CATALOG_COMMENT2')}}:</span>
						{{ pharmacy.comments }}
					</template>

				</div>


				<h2>Mutationen</h2>

				<div class="section columns is-multiline">

					<div class="column is-6">

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_HAS_CUSTOM_DESIGN')}}:</span>
							<span class="value">{{ pharmacy.hasCustomDesign ? 'ja' : 'nein' }}</span>
						</div>

						<div class="row" v-if="pharmacy.voucherPackage">
							<span class="labelName">{{ $t('SITE_CATALOG_VOUCHERS')}}:</span>
							<span class="value">{{ $t('SELECT_VOUCHER-' + pharmacy.voucherPackage.name ) }}</span>
						</div>

						<div class="row" v-if="pharmacy.package && pharmacy.package != null">
							<span class="labelName">{{ $t('SITE_CATALOG_MUTATIONS')}}:</span>
							<span class="value">{{ $t('MUTATION_'+ pharmacy.package.name) }}</span>
						</div>

					</div>

					<div class="column is-6">

					</div>

				</div>

				<div class="mutationBlock" v-if="pharmacy.package && pharmacy.package != null && (pharmacy.package.name == 'U1_U4' || pharmacy.package.name == 'U1_U4_U2' || pharmacy.package.name == 'U1_U4_U2_US')">

					<div class="mutationBlockHeader">
						{{ $t('HEADING-MUTATION_U1_U4') }}
					</div>

					<div class="row">
						<span class="labelName">{{ $t('SITE_CATALOG_CHANGES_U1') }}:</span>
						<span class="value">{{ $t('TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U1_'+getSiteCatalogCustomizationExpense(pharmacy.siteCatalogCustomizations[0].changeExpendituresAmount)) }}</span>
					</div>
					<div class="row">
						<span class="labelName">{{ $t('SITE_CATALOG_COMMENT_U1') }}:</span>
						<span class="value">{{ pharmacy.siteCatalogCustomizations[0].comments }}</span>
					</div>

				</div>

				<template v-if="pharmacy.package && pharmacy.package != null">

					<div class="mutationBlock" v-if="pharmacy.package.name == 'U1_U4_U2' || pharmacy.package.name == 'U1_U4_U2_US'">

						<div class="mutationBlockHeader">
							{{ $t('HEADING-MUTATION_U1_U4_U2') }}
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_CHANGES_U2') }}:</span>
							<span class="value">{{ $t('TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_U2_'+getSiteCatalogCustomizationExpense(pharmacy.siteCatalogCustomizations[1].changeExpendituresAmount)) }}</span>
						</div>
						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_COMMENT_U2') }}:</span>
							<span class="value">{{ pharmacy.siteCatalogCustomizations[1].comments }}</span>
						</div>

					</div>

					<div class="mutationBlock" v-if="pharmacy.package.name == 'U1_U4_U2_US'">

						<div class="mutationBlockHeader">
							{{ $t('HEADING-MUTATION_U1_U4_US') }}
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_CHANGES_US') }}:</span>
							<span class="value">{{ $t('TERM_SITE_CATALOG_CUSTOMIZATION_EXPENSES_US_'+getSiteCatalogCustomizationExpense(typeof pharmacy.siteCatalogCustomizations[2].changeExpendituresAmount != undefined ? pharmacy.siteCatalogCustomizations[2].changeExpendituresAmount : null)) }}</span>
						</div>
						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_COMMENT_US') }}:</span>
							<span class="value">{{ pharmacy.siteCatalogCustomizations[2].comments }}</span>
						</div>

					</div>

					<div class="mutationBlock" v-if="pharmacy.voucherPackage != null && pharmacy.voucherPackage.name != 'NO_VOUCHERS'">

						<div class="mutationBlockHeader">
							{{ $t('HEADING-VOUCHERS') }}
						</div>

						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_CHANGES_VOUCHERS') }}:</span>
							<span class="value">{{ $t('MUTATION_EXPENSE_' + getSiteCatalogCustomizationExpense(pharmacy.voucherChangeExpendituresAmount)) }}</span>
						</div>
						<div class="row">
							<span class="labelName">{{ $t('SITE_CATALOG_COMMENT_VOUCHER') }}:</span>
							<span class="value">{{ pharmacy.voucherComments }}</span>
						</div>

					</div>

				</template>

			</div>

		</template>

	</div>

</template>




<script>


export default {

    name: 'printProduct',

	data() {

		return {
			isLoading: false,
			pharmacy: {}
		}

	},

	computed: {

		siteCatalogStatus() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_STATUS');
		},

		siteCatalogContentCategories() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CONTENT_CATEGORIES');
		},

		siteCatalogCustomizations() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATIONS');
		},

		siteCatalogCustomizationExpenses() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATION_EXPENSES');
		},

		siteCatalogCustomizationPackages() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATION_PACKAGES');
		},

		voucherPackages() {
			return this.$store.getters.getTermsByTaxonomy('VOUCHER_PACKAGES');
		},

		isReadOnly() {
			return this.userRole == 'Kundenbetreuer';
		},

	},


	created() {

		if(this.$route.params.siteID) {

			this.fetchData(this.$route.params.siteID);

		}

	},

	mounted() {


	},

    methods: {

		getSiteCatalogCustomizationExpense(expenditure) {

			if(expenditure == null) {
				return "NONE";
			}

			for (var key in this.siteCatalogCustomizationExpenses) {
				if (this.siteCatalogCustomizationExpenses.hasOwnProperty(key)) {
					if(this.siteCatalogCustomizationExpenses[key].id == expenditure) {
						return this.siteCatalogCustomizationExpenses[key].name;
					}
				}
			}

		},


		getOpeningHours() {

			if(this.pharmacy.site.openingHours == null) {
				return;
			}

			var weekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
			var result = "";
			var self = this;

			weekDays.forEach(function(weekDay) {

				var i = 0;
				result += "<div class='weekDayRow'>";

				self.pharmacy.site.openingHours.forEach(function(openingHour) {

					var startTime = (openingHour.openTime.split('T')[1]).substring(0,5);
					var endTime = (openingHour.closeTime.split('T')[1]).substring(0,5);

					if(weekDay == openingHour.dayInWeek) {

						if(i == 0) {
							result += "<span class='weekDay has-text-grey-dark has-text-weight-normal is-uppercase'>" + self.translateWeekDay(weekDay) + ":</span> " + startTime + "-" + endTime;
							i++;
						} else {
							result += " und " + startTime + "-" + endTime + "<br />";
						}

					}

				});

				result += "</div>";

			});

			return result;

		},

		translateWeekDay(weekDay) {

		    switch(weekDay) {
		        case "MON": return "Mo";
		        case "TUE": return "Di";
		        case "WED": return "Mi";
		        case "THU": return "Do";
		        case "FRI": return "Fr";
		        case "SAT": return "Sa";
		        case "SUN": return "So";
		        default: return "";
		    }

		},


		fetchData(siteId) {

			var self = this;

			this.entitiesGet([
				{
					key: 'siteCatalog',
					params: {
						'filters[catalog.id]': self.catalogId,
						'filters[site.id]': siteId,
						'loadChangesLog': 1,
						'include': [
							'site.openingHours',
							'site.accountManager',
							'site.logoAsset',
							'site.contactPerson',
							'siteCatalog.package',
							'siteCatalog.siteCatalogAssets',
							'siteCatalog.siteCatalogContents',
							'siteCatalog.site',
							'siteCatalog.siteCatalogCustomizations',
							'siteCatalogCustomization.preview',
							'siteCatalog.catalog',
							'siteCatalogAsset.asset',
							'siteCatalog.voucherPackage',
							'siteCatalog.voucherPreview'
						].join(',')
					}
				}
			])
				.then(function(results) {

					self.pharmacy = results.siteCatalog[0];

					// set the voucher package of this site to "NO VOUCHERS" if voucherPackage == null
					if(self.pharmacy.voucherPackage == null) {
						self.pharmacy.voucherPackage = self.voucherPackages.NO_VOUCHERS;
					}

					// make sure the contact person is set, otherwise the binding fails
					if (!self.pharmacy.site.contactPerson) {
						self.pharmacy.site.contactPerson = {
							fullName: ''
						};
					}

					// make sure the account manager is set, otherwise the binding fails
					if (!self.pharmacy.site.accountManager) {
						self.pharmacy.site.accountManager = {
							fullName: ''
						};
					}


					if (!self.pharmacy.site.openingHours.length) {

						var i;

						for (i = 0; i < 7; i++) {

							self.pharmacysite.openingHours.push({
								dayInWeek: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'][i],
								openTime: '08:00',
								closeTime: '18:00',
								site: self.pharmacy.site.id
							});

						}

					}

					if(self.pharmacy.siteCatalogCustomizations.length == 0) {

						for(var i=0; i < 3; i++) {
							self.pharmacy.siteCatalogCustomizations[i] = {
								changeExpendituresAmount: null
							}
						}

					}

				});

		},


    }

}

</script>


<style scoped>

	body {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		background-color: #FAFAFA;
	}
	* {
		box-sizing: border-box;
		-moz-box-sizing: border-box;
	}

	.page {
		width: 210mm;
		min-height: 297mm;
		padding: 20mm;
		margin: 10mm auto;
		border: 1px #D3D3D3 solid;
		border-radius: 5px;
		background: white;
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
		position: relative;
		font-size: 85% !important;
	}



	.page .section {
		margin: 0 0 30px 0 !important;
		padding: 0;
	}

	.page .header {
		position: relative;
		padding-bottom: 15px;
		margin-bottom: 10px;
		border-bottom: 1px solid #888;
	}
	.page .header .logo {
		position: absolute;
		right: 0;
		top: 0;
		width: auto;
		height: 50px;
	}
	.page .header h1 {
		font-size: 1.7rem;
		font-weight: 500;
		margin: 0 0 3pt 0;
	}



	.page .columns {
		margin: 0;
	}
	.page .columns .column {
		padding: 0;
	}
	.page .column:first-child {
		padding-right: 18px;
	}
	.page .column:nth-child(2) {
		padding-left: 18px;
	}


	.page .row {
		display: block;
	}
	.page .row::after {
		content: "";
	    display: table;
	    clear: both;
	}
	.page .labelName {
		font-weight: 500;
	}
	.page .row .labelName {
		float: left;
		display: block;
	}
	.page .row .value {
		display: block;
		text-align: right;
	}

	.page h2 {
		font-size: 11pt;
		font-weight: 400;
		text-transform: uppercase;
		margin: 0 0 10px 0;
		padding: 0 0 5px 0;
		border-bottom: 1px solid #bbb;
	}

	.page .mutationBlock {
		margin: 0 0 5px 0;
		padding: 8px;
		background: #fafafa;
		border: 1px solid #f0f0f0;
	}
	.page .mutationBlockHeader {
		font-size: 1rem;
		margin-bottom: 4px;
	}


	@media all and (min-width: 400px) {

		.columns {
			display: flex;
		}

	}

	.page .openingHours {
		text-align: right !important;
	}
	.subpage {
		padding: 1cm;
		border: 5px red solid;
		height: 257mm;
		outline: 2cm #FFEAEA solid;
		position: relative;
	}


	@page {
		size: A4;
		margin: 0;
	}

	@media print {

		html, body {
			margin: 0 !important;
			width: 210mm;
			height: 297mm;
			background-color: #fff;
			-webkit-print-color-adjust: exact;
		}

		.page {
			background-color: #fff;
			margin: 0;
			border: initial;
			border-radius: initial;
			width: initial;
			min-height: initial;
			box-shadow: initial;
			background: initial;
			page-break-after: always;
			position: relative !important;
			 -webkit-print-color-adjust: exact;
		}
		.printView {
			position: relative;
			background-color: #fff;
			 -webkit-print-color-adjust: exact;
		}
		.printView .bottomLine {
			bottom: 0 !important;
		}
		.printView .pageNumber {
			bottom: 0 !important;
		}

	}

	.printView ul {
		width: 590px !important;
		margin: 0 auto;
		padding: 0;
	}
	.printView ul li {
		position: relative;
		width: 100%;
		height: auto;
		margin: 10px 0;
		padding: 0;
	}
	.printView ul li .columns {
		margin: 0;
		padding: 0;
	}
	.printView .bottomLine {
		position: absolute;
		bottom: 22mm;
		left: 22mm;
		right: 22mm;
		height: auto;
	}
	.printView .bottomLine .status {
		text-transform: uppercase;
		font-weight: 500;
		display: block;
	}
	.printView .bottomLine .log {
		font-size: 12px;
	}
	.printView .bottomLine .logAuthor {
		font-weight: 400;
	}
	.printView .bottomLine .logDate {
		font-weight: 400;
	}

	.printView .pageNumber {
		position: absolute;
		bottom: 22mm;
		left: auto;
		right: 22mm;
		text-align: right;
		width: 100px;
		height: auto;
		font-size: 14px;
	}
	.printView .productVoucherImg {
		margin: 0 0 15px 0;
		width: 300px;
	}
</style>
